import {
  ApplicationConfig,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import {environment } from '../environments/environment'

import {
  CalGuardService,
  CalAngularService,
  CalAngularModule
} from '@cvx/cal-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),

    importProvidersFrom(
      BrowserModule,
      HttpClientModule, // <-- add this

      CalAngularModule.forRoot({
        autoSignIn: true,
        popupForLogin: false,
        cacheLocation: 'localStorage',
        instance: 'https://login.microsoftonline.com/',
        tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
        clientId: environment.clientId,
        redirectUri: environment.redirectUri, 
        oidcScopes: ['openid', 'profile', 'email', 'offline_access'],
        graphScopes: ['User.Read', 'User.Read.All'],
      })
    ),

    CalAngularService,
    CalGuardService,
  ],
};